module.exports = __webpack_public_path__ + "img/depot.6ea522a4.svg";